import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';

const NotFoundPage = () => {
  return (
    <>
      <PageSEO
        title="Страница не найдена — 404"
        description="Запрашиваемая страница не существует. Вернитесь на главную или перейдите в каталог."
        canonical="/404"
        noindex={true}
      />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-8xl font-bold text-gray-200 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Страница не найдена</h2>
          <p className="text-gray-500 mb-8">
            Возможно, страница была удалена или вы перешли по неверной ссылке.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-block bg-black text-white px-6 py-3 rounded-md font-medium hover:bg-gray-800 transition-colors"
            >
              На главную
            </Link>
            <Link
              to="/catalog"
              className="inline-block border border-gray-300 text-gray-700 px-6 py-3 rounded-md font-medium hover:border-gray-500 transition-colors"
            >
              Каталог
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
